// @flow
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useOutdatedSql } from '../../hooks/use-outdated-sql';
import { keycloak } from '@coverright/shared/keycloak';
import { SalesQualified } from './sales-qualified';
import { dataSource } from '../../lib/emulated-data-source';


export const OutdatedSalesQualified = () => {
  const {agentId} = useParams<{ agentId?: string }>();
  const outdated = useOutdatedSql(agentId)

  return (
    <SalesQualified suffix={'Outdated'}
                    dataSource={dataSource('salesQualified', outdated)}
                    title={'Outdated Sales Qualified'}
                    agent={agentId || keycloak?.tokenParsed?.sub} />
  );
};
